module.exports = __webpack_public_path__ + "static/img/5284_phase_function_Paper_PointsHejduk_Prediction.36417a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5284_phase_function_Paper_PointsHejduk_Prediction.png
// module id = YSlH
// module chunks = 0